import React from 'react';
import MapContainer from '../../components/map/MapContainer';

//Componentes
import ViniedoLogsContainer from '../../components/viniedoLogs/ViniedoLogsContainer';
import { formatNumberLength } from '../../helpers';

//Estilos
import './Vineyard.css';
import './VineyardMediaQueries.css';

function Vineyard({ states, functions }) {
    const { user, VineyardData, watchViniedoLogs, Coordinates } = states;
    const { setWatchViniedoLogs } = functions;
    const attributes = VineyardData?.features?.features[0].attributes;
    const geometry = VineyardData?.features?.features[0].geometry;
    const cuadros = VineyardData?.cuadros;
    let variedades = [];
    cuadros?.map((c) => {
        if (!variedades.includes(c.variedad)) variedades.push(c.variedad);

        return variedades;
    });
    const padronesPatterns = new RegExp('[/_]', 'g');

    return (
        <div className="vineyard_data-container">
            <h4 className="vineyard_data-title">
                Viñedo #{attributes?.vinedo}
            </h4>
            <section className="vineyard_data-map">
                <MapContainer states={{ isOpen: true, VineyardData }} />
            </section>
            <section className="vineyard_data-info-section">
                <label className="vineyard_data-label">
                    <span>Titular/es: </span>
                    <p>{attributes?.titulaR_VINEDO}</p>
                </label>
                <label className="vineyard_data-label">
                    <span>Superficie: </span>
                    <p>{attributes?.area} m²</p>
                </label>
                <label className="vineyard_data-label">
                    <span>Padrones: </span>
                    <p>
                        {attributes?.padrones.replaceAll(
                            padronesPatterns,
                            ', '
                        )}
                    </p>
                </label>
                <label className="vineyard_data-label">
                    <span>Ubicación: </span>
                    <ul>
                        <li>{`Latitud: ${formatNumberLength(
                            Coordinates?.lat,
                            8
                        )}`}</li>
                        <li>{`Longitud: ${formatNumberLength(
                            Coordinates?.lon,
                            8
                        )}`}</li>
                    </ul>
                </label>
                <label className="vineyard_data-label">
                    <span>Variedades: </span>
                    <ul>
                        {variedades?.map((v, i) => {
                            return <li key={i}>{v}</li>;
                        })}
                    </ul>
                    {/* <p>{variedades?.join(', ')}</p> */}
                </label>
                <label className="vineyard_data-label">
                    <span>Departamento: </span>
                    <p>{attributes?.dpto}</p>
                </label>
                <label className="vineyard_data-label">
                    <span>Seccional: </span>
                    <p>{VineyardData?.seccional}</p>
                </label>
            </section>

            {user.tipo === 3 && (
                <fieldset className="profile-fieldset_4">
                    <h4 className="profile-title">Historial del Viñedo</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchViniedoLogs(!watchViniedoLogs)}
                    >
                        {!watchViniedoLogs
                            ? 'Ver Historial'
                            : 'Ocultar Historial'}
                    </button>
                    {watchViniedoLogs && <ViniedoLogsContainer />}
                </fieldset>
            )}
        </div>
    );
}

export default Vineyard;
